import LabeledSelect from './LabeledSelect'
import {  useEffect, useState } from 'react'
import { getAllDynamicUiPages } from 'redux/sagas/requests/pageService'

const PagesSelect = ({
  label,
  value,
  onChange,
  placeholder = 'Select Pages',
  emptyMsg = 'No data',
  extData,
  ...props
}) => {
  //todo search a better way to load default values
  const [isFetching, setIsFetching] = useState(false)
  const [pages, setPages] = useState([])

  useEffect(() => {
    if (extData && !value && !isFetching && onChange) {
      setIsFetching(true)
      getAllDynamicUiPages()
        .then((resp) => {
          setIsFetching(false)
          setPages(resp.data.data);
          onChange(
            resp.data.data.find((rsp) => rsp.id === extData),
          )
        })
        .catch((err) => {
          setIsFetching(false)
        })
    }
  }, [extData])

  useEffect(() => {
    if (!extData) {
      setIsFetching(true)
      getAllDynamicUiPages()
        .then((resp) => {
          setIsFetching(false)
          onChange(resp.data)
          setPages(resp.data.data)
        })
        .catch((err) => {
          setIsFetching(false)
        })
    }
  }, [])

  return (
    <LabeledSelect
      label={label}
      value={value}
      getOptionLabel={(option) => option.title}
      loading={isFetching}
      isDisabled={isFetching}
      getOptionValue={(option) => option.id}
      placeholder={placeholder}
      onChange={onChange}
      emptyMsg={emptyMsg}
      {...props}
      options={pages}
    />
  )
}

export default PagesSelect
